<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="tochead"><b>Table of Contents</b></p>
<p class="toc"><a href="#/chap01">Ciphers</a></p>
<p class="toc"><a href="#/chap02">Lucky Dip</a></p>
<p class="toc"><span href="#/chap03" title="Link target outside of Sample">The Cure</span></p>
<p class="toc"><span href="#/chap04" title="Link target outside of Sample">Tears of Kamala</span></p>
<p class="toc"><span href="#/chap05" title="Link target outside of Sample">Younger Wife</span></p>
<p class="toc"><span href="#/chap06" title="Link target outside of Sample">Shakuntala</span></p>
<p class="toc"><span href="#/chap07" title="Link target outside of Sample">Waxing the Thing</span></p>
<p class="toc"><span href="#/chap08" title="Link target outside of Sample">Maria</span></p>
<p class="toc"><span href="#/chap09" title="Link target outside of Sample">This Anju</span></p>
<p class="toc"><span href="#/chap10" title="Link target outside of Sample">Just Between Indians</span></p>
<p class="toc"><span href="#/chap11" title="Link target outside of Sample">The Smell</span></p>
<p class="toc"><span href="#/chap12" title="Link target outside of Sample">Glossary</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?6a6df4fd